export const couplesLoactionFeaturesList = [
    {
        id: '1',
        title: 'Live Location Sharing',
        content: 'Know where your partner is without having to ask. See their real-time location when they’re heading home, out for a run, or travelling.',
        imgName: 'locationSharingCarousell'
    },
    {
        id: '2',
        title: 'Instant Messaging',
        content: "Keep your conversations and locations in one place. Message directly in the app for quick updates and check-ins.",
        imgName: 'messegesCarousel'
    },
    {
        id: '3',
        title: 'Location History',
        content: "Keep track of where you’ve been and how far you’ve travelled with 30 days of accurate location history.",
        imgName: 'locationHistoryCarousel'
    },
    {
        id: '4',
        title: 'Check-In',
        content: 'A simple way to say, “I made it.” One tap, and your partner knows you’re safe.',
        imgName: 'checkInCarousel'
    },

];